(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bls-homepage"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";

  function init() {
    var root = document.querySelector(".bls-home");
    if (!root) { return; }

    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    /* Stagger children of any reveal group */
    root.querySelectorAll("[data-reveal-group]").forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, i) {
        child.setAttribute("data-reveal", "");
        child.style.transitionDelay = (i * 90) + "ms";
      });
    });

    /* Reveal on scroll */
    var revealEls = root.querySelectorAll("[data-reveal]");
    if (reduced || !("IntersectionObserver" in window)) {
      revealEls.forEach(function (el) { el.classList.add("revealed"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("revealed");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -6% 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bls-see-in-dark"] && !Shopify.designMode) return;
  try {
    
(function () {
  "use strict";
  function initStage(root) {
    var stage = root.querySelector(".bls-sid__stage");
    if (!stage || stage.dataset.sidReady === "1") { return; }
    stage.dataset.sidReady = "1";
    var caption = root.querySelector("[data-sid-caption]");
    var remote  = root.querySelector(".bls-sid__remote");
    var buttons = Array.prototype.slice.call(root.querySelectorAll(".bls-sid__preset"));
    var layers  = Array.prototype.slice.call(root.querySelectorAll(".bls-sid__layer"));
    var dragging = false;
    function setX(clientX) {
      var r = stage.getBoundingClientRect();
      if (!r.width) { return; }
      var pct = Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100));
      stage.style.setProperty("--sid-x", pct + "%");
      stage.setAttribute("aria-valuenow", String(Math.round(pct)));
    }
    stage.addEventListener("pointerdown", function (e) {
      if (stage.classList.contains("is-solo")) { return; }
      dragging = true; setX(e.clientX); e.preventDefault();
    });
    document.addEventListener("pointermove", function (e) { if (dragging) { setX(e.clientX); } });
    document.addEventListener("pointerup", function () { dragging = false; });
    document.addEventListener("pointercancel", function () { dragging = false; });
    stage.addEventListener("keydown", function (e) {
      if (stage.classList.contains("is-solo")) { return; }
      var cur = parseFloat(stage.getAttribute("aria-valuenow")) || 50;
      var step = e.shiftKey ? 10 : 4;
      if (e.key === "ArrowLeft") { cur -= step; }
      else if (e.key === "ArrowRight") { cur += step; }
      else { return; }
      e.preventDefault();
      cur = Math.min(100, Math.max(0, cur));
      stage.style.setProperty("--sid-x", cur + "%");
      stage.setAttribute("aria-valuenow", String(Math.round(cur)));
    });
    stage.style.setProperty("--sid-x", "50%");
    function select(btn) {
      buttons.forEach(function (b) { b.setAttribute("aria-pressed", b === btn ? "true" : "false"); });
      layers.forEach(function (l) { l.classList.remove("is-active"); });
      if (btn.dataset.sidMode === "off") { stage.classList.add("is-solo"); }
      else {
        stage.classList.remove("is-solo");
        var layer = document.getElementById(btn.dataset.sidLayer);
        if (layer) { layer.classList.add("is-active"); }
        if (caption) { caption.textContent = btn.textContent.trim(); }
      }
      if (remote && remote.scrollWidth > remote.clientWidth) {
        var target = btn.offsetLeft - (remote.clientWidth - btn.offsetWidth) / 2;
        remote.scrollTo({ left: Math.max(0, target), behavior: "smooth" });
      }
    }
    buttons.forEach(function (b) { b.addEventListener("click", function () { select(b); }); });
  }
  function initAll(scope) { (scope || document).querySelectorAll(".bls-sid").forEach(initStage); }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(); });
  } else { initAll(); }
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
  document.addEventListener("shopify:block:select", function (e) {
    var btn = e.target.closest ? e.target.closest(".bls-sid__preset") : null;
    if (btn) { btn.click(); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
